webpackJsonp([165990460456080],{

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CouncilMember = function (_Component) {
	  _inherits(CouncilMember, _Component);
	
	  function CouncilMember() {
	    _classCallCheck(this, CouncilMember);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CouncilMember.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        designation = _props.designation,
	        imageUrl = _props.imageUrl;
	
	    return _react2.default.createElement(
	      _styledComponents.MainContainer,
	      null,
	      _react2.default.createElement(_styledComponents.ProfilesImage, { dataSrc: imageUrl, alt: name, className: 'lazyload' }),
	      _react2.default.createElement(
	        _styledComponents.NameText,
	        null,
	        ' ',
	        name,
	        ' '
	      ),
	      _react2.default.createElement(
	        _styledComponents.Designation,
	        null,
	        designation
	      )
	    );
	  };
	
	  return CouncilMember;
	}(_react.Component);
	
	exports.default = CouncilMember;
	module.exports = exports['default'];

/***/ }),

/***/ 1486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Designation = exports.NameText = exports.ProfilesImage = exports.MainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e19tbai10'
	})('display:flex;flex-direction:column;align-items:center;', _mixins.mobile, '{margin-bottom:30px;&:last-child{margin-bottom:0px;}}');
	var ProfilesImage = /*#__PURE__*/exports.ProfilesImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e19tbai11'
	})('height:190px;width:190px;border-radius:50%;');
	
	var NameText = /*#__PURE__*/exports.NameText = (0, _reactEmotion2.default)(_Din.Typo20WhiteFourDD, {
	  target: 'e19tbai12'
	})('color:', _Colors2.default.charcoalGreyTwo, ';line-height:normal;letter-spacing:normal;text-align:center;margin-top:0.9375em;');
	var Designation = /*#__PURE__*/exports.Designation = (0, _reactEmotion2.default)(_Din.Typo16GainsBoroDD, {
	  target: 'e19tbai13'
	})('color:', _Colors2.default.charcoalGreyTwo, ';text-align:center;');

/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CouncilMember = __webpack_require__(1485);
	
	var _CouncilMember2 = _interopRequireDefault(_CouncilMember);
	
	var _styledComponents = __webpack_require__(1488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvisoryCouncilSection = function (_PureComponent) {
	  _inherits(AdvisoryCouncilSection, _PureComponent);
	
	  function AdvisoryCouncilSection() {
	    _classCallCheck(this, AdvisoryCouncilSection);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  AdvisoryCouncilSection.prototype.render = function render() {
	    var gamingAdvisoryCouncilData = this.props.gamingAdvisoryCouncilData;
	    var title = gamingAdvisoryCouncilData.title,
	        councilMembersList = gamingAdvisoryCouncilData.councilMembersList;
	
	    return _react2.default.createElement(
	      _styledComponents.AdvisoryCouncilContainer,
	      { id: 'global-advisory-section' },
	      _react2.default.createElement(
	        _styledComponents.Title,
	        { as: 'h3' },
	        title
	      ),
	      _react2.default.createElement(
	        _styledComponents.CouncilMembersContainer,
	        null,
	        councilMembersList.map(function (_ref) {
	          var name = _ref.name,
	              designation = _ref.designation,
	              imageUrl = _ref.imageUrl;
	          return _react2.default.createElement(_CouncilMember2.default, {
	            name: name,
	            designation: designation,
	            imageUrl: imageUrl
	          });
	        })
	      )
	    );
	  };
	
	  return AdvisoryCouncilSection;
	}(_react.PureComponent);
	
	exports.default = AdvisoryCouncilSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CouncilMembersContainer = exports.Description = exports.Title = exports.AdvisoryCouncilContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Din = __webpack_require__(8);
	
	var _mixins = __webpack_require__(4);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styedComponents = __webpack_require__(450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvisoryCouncilContainer = /*#__PURE__*/exports.AdvisoryCouncilContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'eqiuiul0'
	})('display:flex;flex-direction:column;align-items:center;');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)(_styedComponents.SectionHeading, {
	  target: 'eqiuiul1'
	})('margin-bottom:24px;margin-top:0;');
	
	var Description = /*#__PURE__*/exports.Description = (0, _reactEmotion2.default)(_Din.Type16VeryLightPinkDR, {
	  target: 'eqiuiul2'
	})('color:', _Colors2.default.darkGreyBlue, ';text-align:center;width:100%;margin-top:10px;margin-bottom:40px;', _mixins.mobile, '{margin-top:30px;margin-bottom:30px;font-size:14px;}');
	
	var CouncilMembersContainer = /*#__PURE__*/exports.CouncilMembersContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eqiuiul3'
	})('display:flex;justify-content:space-around;width:100%;margin-top:40px;', _mixins.mobile, '{flex-direction:column;align-items:center;}', _mixins.tablet, '{width:100%;}');

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(1490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationSection = function (_Component) {
	  _inherits(OrganizationSection, _Component);
	
	  function OrganizationSection() {
	    _classCallCheck(this, OrganizationSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OrganizationSection.prototype.render = function render() {
	    var _props = this.props,
	        imageUrl = _props.imageUrl,
	        title = _props.title,
	        content = _props.content;
	
	
	    return _react2.default.createElement(
	      _styledComponents.OrganizationContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.ImageContainer,
	        null,
	        _react2.default.createElement(_styledComponents.Image, { dataSrc: imageUrl, alt: title, className: 'lazyload' })
	      ),
	      _react2.default.createElement(
	        _styledComponents.ContentContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.ContentTitle,
	          { as: 'article' },
	          title
	        ),
	        _react2.default.createElement(
	          _styledComponents.ContentDescription,
	          { as: 'article' },
	          content
	        )
	      )
	    );
	  };
	
	  return OrganizationSection;
	}(_react.Component);
	
	exports.default = OrganizationSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1490:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ImageContainer = exports.ContentDescription = exports.ContentTitle = exports.ContentContainer = exports.Image = exports.OrganizationContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganizationContainer = /*#__PURE__*/exports.OrganizationContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e1b6a1v40'
	})('width:50%;display:flex;align-items:flex-start;justify-content:flex-start;', _mixins.mobile, '{width:100%;flex-direction:column;&:first-child{margin-bottom:30px;}justify-content:center;align-items:center;}', _mixins.tablet, '{width:100%;&:first-child{margin-bottom:30px;}}');
	var Image = /*#__PURE__*/exports.Image = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e1b6a1v41'
	})(_mixins.mobile, '{margin:auto;}');
	
	var ContentContainer = /*#__PURE__*/exports.ContentContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1b6a1v42'
	})('display:flex;flex-direction:column;align-items:flex-start;padding-right:40px;margin-left:30px;', _mixins.mobile, '{align-items:center;margin-left:unset;padding-left:10px;padding-right:10px;}');
	var ContentTitle = /*#__PURE__*/exports.ContentTitle = (0, _reactEmotion2.default)(_Din.Typo18DarkGreyBlueTwoDDI, {
	  target: 'e1b6a1v43'
	})('text-align:left;margin-top:20px;', _mixins.mobile, '{text-align:center;}');
	var ContentDescription = /*#__PURE__*/exports.ContentDescription = (0, _reactEmotion2.default)(_Din.Typo14BlueGreyDR, {
	  target: 'e1b6a1v44'
	})('text-align:left;margin-top:10px;margin-bottom:20px;', _mixins.mobile, '{text-align:center;}');
	var ImageContainer = /*#__PURE__*/exports.ImageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1b6a1v45'
	})();

/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _OrganizationSection = __webpack_require__(1489);
	
	var _OrganizationSection2 = _interopRequireDefault(_OrganizationSection);
	
	var _styledComponents = __webpack_require__(1492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationSection = function (_React$Component) {
	  _inherits(ApplicationSection, _React$Component);
	
	  function ApplicationSection() {
	    _classCallCheck(this, ApplicationSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ApplicationSection.prototype.render = function render() {
	    var applicationSectionData = this.props.applicationSectionData;
	    var title = applicationSectionData.title,
	        organizationsList = applicationSectionData.applicationsList;
	
	    return React.createElement(
	      _styledComponents.Container,
	      { id: 'what-we-do-section' },
	      React.createElement(
	        _styledComponents.ResponsiveContainer,
	        null,
	        React.createElement(
	          _styledComponents.Title,
	          { as: 'h2' },
	          title
	        ),
	        React.createElement(_styledComponents.TitleUnderLine, null),
	        React.createElement(
	          _styledComponents.DevelopSectionContainer,
	          null,
	          organizationsList.map(function (eachOrganization) {
	            return React.createElement(_OrganizationSection2.default, {
	              imageUrl: eachOrganization.imageUrl,
	              title: eachOrganization.title,
	              content: eachOrganization.content
	            });
	          })
	        )
	      )
	    );
	  };
	
	  return ApplicationSection;
	}(React.Component);
	
	exports.default = ApplicationSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ResponsiveContainer = exports.DevelopSectionContainer = exports.TitleUnderLine = exports.Title = exports.Container = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Nort = __webpack_require__(11);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/exports.Container = (0, _reactEmotion2.default)('div', {
	  target: 'ek9vs1h0'
	})('background-color:', _Colors2.default.lightBlueTwo, ';padding-top:50px;padding-bottom:70px;', _mixins.mobile, '{padding-top:40px;padding-bottom:40px;}');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)(_Nort.Typo30DarkGreyBlueTwoNBI, {
	  target: 'ek9vs1h1'
	})('text-align:center;', _mixins.mobile, '{font-size:26px;}margin:0;');
	var TitleUnderLine = /*#__PURE__*/exports.TitleUnderLine = (0, _reactEmotion2.default)('div', {
	  target: 'ek9vs1h2'
	})('width:100px;height:2px;background-color:', _Colors2.default.pumpkinOrange, ';margin:auto;margin-top:10px;');
	var DevelopSectionContainer = /*#__PURE__*/exports.DevelopSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ek9vs1h3'
	})('display:flex;flex-direction:row;flex-wrap:wrap;width:100%;margin-top:40px;', _mixins.mobile, '{flex-direction:column;align-items:center;width:100%;margin-top:0;}', _mixins.tablet, '{flex-direction:column;}');
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'ek9vs1h4'
	})('text-align:center;');

/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(165);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _emotionTheming = __webpack_require__(59);
	
	var _themeConstants = __webpack_require__(80);
	
	var _themeConstants2 = _interopRequireDefault(_themeConstants);
	
	var _stylesModule = __webpack_require__(1870);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _styledComponents = __webpack_require__(1494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentSection = function ContentSection(props) {
	  return _react2.default.createElement(
	    _styledComponents.FutureTextItem,
	    null,
	    _react2.default.createElement(
	      _styledComponents.FutureItemTitle,
	      { as: 'h3' },
	      props.futureItemTitle
	    ),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { query: '(max-device-width: 767px)' },
	      props.galleryPresent ? _react2.default.createElement(_styledComponents.FutureImageItem, null) : _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.futureImageItem + ' ' + props.optional },
	        _react2.default.createElement(
	          _styledComponents.FutureItemHead,
	          null,
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { query: '(min-device-width: 768px)' },
	            _react2.default.createElement(_styledComponents.FutureItemImg, {
	              dataSrc: props.webpsrc || props.mainImage,
	              alt: props.futureItemTitle,
	              className: 'lazyload'
	            })
	          ),
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { query: '(max-device-width: 767px)' },
	            _react2.default.createElement(_styledComponents.FutureItemImg, {
	              dataSrc: props.webpsrc || props.mobileImage,
	              alt: props.futureItemTitle,
	              className: 'lazyload'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _styledComponents.FutureItemDescription,
	      null,
	      props.futureItemDescription
	    )
	  );
	};
	
	var ImageSection = function ImageSection(props) {
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { query: '(min-device-width: 768px)' },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.futureImageItem + ' ' + props.optional },
	      _react2.default.createElement(
	        _styledComponents.FutureItemHead,
	        null,
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { query: '(min-device-width: 768px)' },
	          _react2.default.createElement(_styledComponents.SectionImage, {
	            dataSrc: props.webpsrc || props.mainImage,
	            alt: props.futureItemTitle,
	            className: 'lazyload'
	          })
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { query: '(max-device-width: 767px)' },
	          _react2.default.createElement(_styledComponents.SectionImage, {
	            dataSrc: props.webpsrc || props.mobileImage,
	            alt: props.futureItemTitle,
	            className: 'lazyload'
	          })
	        )
	      )
	    )
	  );
	};
	
	var LeftImageComponent = function LeftImageComponent(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.vcenter, style: { width: props.imageWidth + '%' } },
	      _react2.default.createElement(ImageSection, props)
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: _stylesModule2.default.vcenter,
	        style: { width: props.contentWidth + '%', paddingLeft: '5.188em' }
	      },
	      _react2.default.createElement(ContentSection, props)
	    )
	  );
	};
	
	LeftImageComponent.defaultProps = {
	  imageWidth: 50,
	  contentWidth: 50
	};
	
	var RightImageComponent = function RightImageComponent(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        className: _stylesModule2.default.vcenter,
	        style: { width: props.contentWidth + '%', paddingRight: '5.188em' }
	      },
	      _react2.default.createElement(ContentSection, props)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.vcenter, style: { width: props.imageWidth + '%' } },
	      _react2.default.createElement(ImageSection, props)
	    )
	  );
	};
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.componentDidMount = function componentDidMount() {};
	
	  Section.prototype.render = function render() {
	    return _react2.default.createElement(
	      _emotionTheming.ThemeProvider,
	      { theme: _themeConstants2.default },
	      _react2.default.createElement(
	        _styledComponents.FutureSection,
	        { id: this.props.id },
	        this.props.imagePosition === 'LEFT' ? _react2.default.createElement(LeftImageComponent, this.props) : _react2.default.createElement(RightImageComponent, this.props)
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FutureItemDescription = exports.FutureSection = exports.FutureImageItem = exports.FutureItemTitle = exports.FutureItemHead = exports.FutureTextItem = exports.FutureItemImg = exports.SectionImage = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Nort = __webpack_require__(11);
	
	var _Din = __webpack_require__(8);
	
	var _mixins = __webpack_require__(4);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionImage = /*#__PURE__*/exports.SectionImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e7bf1qv0'
	})('width:99%;object-fit:contain;background-color:transparent;margin:0px;');
	
	var FutureItemImg = /*#__PURE__*/exports.FutureItemImg = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e7bf1qv1'
	})('width:99%;object-fit:contain;background-color:transparent;margin:0px;');
	
	var FutureTextItem = /*#__PURE__*/exports.FutureTextItem = (0, _reactEmotion2.default)('div', {
	  target: 'e7bf1qv2'
	})('display:flex;flex-direction:column;border-radius:6px;', _mixins.mobile, '{align-items:center;}');
	var FutureItemHead = /*#__PURE__*/exports.FutureItemHead = (0, _reactEmotion2.default)('div', {
	  target: 'e7bf1qv3'
	})('text-align:center;');
	
	var FutureItemTitle = /*#__PURE__*/exports.FutureItemTitle = (0, _reactEmotion2.default)(_Nort.Typo24DarkGreyBlueTwoNBI, {
	  target: 'e7bf1qv4'
	})('align-self:flex-start;text-align:left;margin:0;line-height:normal;', _mixins.mobile, '{margin:0;margin-top:30px;text-align:center;margin-bottom:10px;align-self:center;font-size:18px;}');
	var FutureImageItem = /*#__PURE__*/exports.FutureImageItem = (0, _reactEmotion2.default)('div', {
	  target: 'e7bf1qv5'
	})('display:flex;flex-direction:column;padding:5% 2%;border-radius:6px;@media (min-width:426px) and (max-width:767px){padding:20px 3px;}@media screen and (max-width:425px){padding:15px 0px;}');
	
	var FutureSection = /*#__PURE__*/exports.FutureSection = (0, _reactEmotion2.default)('section', {
	  target: 'e7bf1qv6'
	})(_mixins.tablet, '{margin-bottom:40px;}');
	
	var FutureItemDescription = /*#__PURE__*/exports.FutureItemDescription = (0, _reactEmotion2.default)(_Din.Typo14BlueGreyDR, {
	  target: 'e7bf1qv7'
	})('margin-top:10px;', _mixins.mobile, '{text-align:center;}');

/***/ }),

/***/ 1870:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"futureImageItem":"src-components-TeamNew-FollowUsSection-components-Section----styles-module---futureImageItem---UN0gK","vcenter":"src-components-TeamNew-FollowUsSection-components-Section----styles-module---vcenter---3ihNX"};

/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _stylesModule = __webpack_require__(1871);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Section = __webpack_require__(1493);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _data = __webpack_require__(1497);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _styledComponents = __webpack_require__(1496);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FollowUsSection = function (_Component) {
	  _inherits(FollowUsSection, _Component);
	
	  function FollowUsSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FollowUsSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderStakeHolder = function (stakeholder, index) {
	      return _react2.default.createElement(_Section2.default, {
	        id: stakeholder.sectionId,
	        key: stakeholder.title,
	        futureItemBottomDescription: stakeholder.callToAction,
	        futureItemDescription: stakeholder.description,
	        futureItemSubTitle: stakeholder.tagline,
	        futureItemTitle: stakeholder.title,
	        imagePosition: index % 2 === 0 ? 'RIGHT' : 'LEFT',
	        rightButton: _stylesModule2.default.rightButton,
	        link: stakeholder.redirect,
	        imagesPath: stakeholder.imagePath,
	        mainImage: stakeholder.mainImage,
	        mobileImage: stakeholder.mobileImage,
	        applyText: stakeholder.apply,
	        areahidden: _data2.default.moreSection.GamePublish.areahidden
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FollowUsSection.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        stakeholdersData = _props.stakeholdersData,
	        stakeholdersList = _props.stakeholdersList,
	        invertTheme = _props.invertTheme;
	    var title = stakeholdersData.title,
	        sectionId = stakeholdersData.sectionId;
	
	    return _react2.default.createElement(
	      _styledComponents.FutureSection,
	      {
	        id: sectionId,
	        className: _stylesModule2.default.futureSection,
	        ref: function ref(c) {
	          _this2.section = c;
	        },
	        invertTheme: invertTheme
	      },
	      _react2.default.createElement(
	        _ResponsiveContainer2.default,
	        null,
	        _react2.default.createElement(
	          _styledComponents.TitleContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.Title,
	            { as: 'h2' },
	            title
	          ),
	          _react2.default.createElement(_styledComponents.TitleUnderLine, { invertTheme: invertTheme })
	        ),
	        stakeholdersList.map(function (stakeholder, index) {
	          return _this2.renderStakeHolder(stakeholder, index);
	        })
	      )
	    );
	  };
	
	  return FollowUsSection;
	}(_react.Component);
	
	exports.default = FollowUsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TitleUnderLine = exports.Title = exports.TitleContainer = exports.FutureSection = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Nort = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FutureSection = /*#__PURE__*/exports.FutureSection = (0, _reactEmotion2.default)('section', {
	  target: 'eyapt310'
	})('background-color:', function (props) {
	  return props.invertTheme ? _Colors2.default.lightBlueTwo : _Colors2.default.white;
	}, ';padding-top:60px;padding-bottom:5em;', _mixins.mobile, '{padding-top:3.786em;font-size:14px;padding-bottom:4.286em;}');
	
	var TitleContainer = /*#__PURE__*/exports.TitleContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eyapt311'
	})('width:100%;display:flex;flex-direction:column;align-items:center;');
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)(_Nort.Typo30DarkGreyBlueTwoNBI, {
	  target: 'eyapt312'
	})('text-align:center;letter-spacing:0.5px;line-height:normal;', _mixins.mobile, '{font-size:24px;}margin:0;');
	var TitleUnderLine = /*#__PURE__*/exports.TitleUnderLine = (0, _reactEmotion2.default)('div', {
	  target: 'eyapt313'
	})('width:100px;height:2px;background-color:', function (props) {
	  return props.invertTheme ? _Colors2.default.pumpkinOrange : _Colors2.default.ceruleanBlue;
	}, ';margin:auto;margin-top:10px;');

/***/ }),

/***/ 1871:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"coeBackground":"src-components-TeamNew-FollowUsSection----styles-module---coeBackground---XLG6i","divider":"src-components-TeamNew-FollowUsSection----styles-module---divider---36_tG"};

/***/ }),

/***/ 1497:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var headerSection = {
	  mainHeading: 'Making India a world leader in Virtual reality and Augmented reality',
	  secondHeading: "VR and AR are changing the way we experience, create and learn We're building an ecosystem to accelerate this change"
	};
	
	var moreSection = {
	  Revenue: {
	    mainHeading: 'AR & VR Revenue ',
	    secondHeading: 'to hit $108 Billion by 2021',
	    description: 'With AR & VR penetrating into diverse sectors and impacting lifestyle of many, these technologies are going to disrupt the industry with a CAGR 94.3% from $3.9 billion in 2016 to $108 billion by 2021. ',
	    mainImage: 'https://s3-eu-west-1.amazonaws.com/newsletter-static-media/vr_site/for_section/graph.png',
	    webpsrc: 'https://d1ov0p6puz91hu.cloudfront.net/AR-VR/Backgrounds/graph.webp',
	    link: '/learners',
	    alt: 'ib VR AR Revenue Graph',
	    applyText: '',
	    areahidden: 'none'
	  },
	  Learners: {
	    mainHeading: 'For Learners',
	    secondHeading: 'Build your career in VR/AR',
	    description: 'VR allows users to experience a different world giving unmatched amount of freedom for creators. As the industry is growing at 94.3%, so are the career opportunities. Applications of VR/AR are limitless.',
	    want: 'Want to get started?',
	    apply: 'Apply Now',
	    link: '/learners',
	    mainImage: '/assets/images/ForLearners/forlearners.png',
	    alt: 'ib VR AR Learners',
	    imagesPath: '/assets/images/ForLearners/',
	    applyText: 'Apply Now',
	    areahidden: ''
	  },
	  GamePublish: {
	    mainHeading: 'For Game Publishers',
	    secondHeading: 'Fast track your success!',
	    description: 'With our widely established global and PAN India VR/AR Ecosystem, you can gain traction exponentially and expand at scale. Deep dive into the product development and leave the rest to us.',
	    want: 'Want to connect with us?',
	    apply: 'Apply Now',
	    link: '/game-developers',
	    mainImage: '/assets/images/ForGamePublish/gamepublishers.png',
	    alt: 'ib VR AR Game Publishers',
	    imagesPath: '/assets/images/ForGamePublish/',
	    applyText: 'Apply Now',
	    areahidden: ''
	  },
	  Organisations: {
	    mainHeading: 'For Organizations',
	    secondHeading: 'Get assistance with VR/AR technology for better business outcomes.',
	    description: 'Organisations across domains can use this technology in enhancing their products or services, capacity building and improving productivity of employees, giving immersive demos, visualizing data, rapid prototyping and testing, and many more.',
	    want: 'Want assistance in building VR/AR products for you?',
	    apply: 'Apply Now',
	    link: '/business',
	    mainImage: 'https://s3-eu-west-1.amazonaws.com/newsletter-static-media/vr_site/for_section/oraganizations.jpg',
	    alt: 'ib VR AR Organisations',
	    imagesPath: '/assets/images/ForOrganisations/',
	    applyText: 'Get in Touch',
	    areahidden: ''
	  }
	};
	
	var coreTeam = {
	  mainHeading: 'Core Team',
	  secondHeading: 'Our core team members are alumni of best colleges of India and are set out to make iB as one of the world’s leading company in VR/AR Industry',
	  bottomContent: 'We are supported by 1000 highly talented youngsters from national and international institutions of whom 150 are working full time.Majority of us are alumni of premier institutes like IITs, IIMs and corporate alumni of major MNCs.'
	};
	
	var shareVision = {
	  mainHeading: 'Share your vision for the future'
	};
	
	var LaunchingProductDetails = {
	  image: 'https://d1ov0p6puz91hu.cloudfront.net/AR-VR/iBC-Logo.png',
	  mainHeading: 'iB CRICKET',
	  subHeading: 'Launching our First Product...',
	  description: "A world's first of its kind <b>VR Cricket Sport</b> with the most immersive cricketing game-play experience."
	};
	
	exports.default = {
	  headerSection: headerSection,
	  moreSection: moreSection,
	  coreTeam: coreTeam,
	  shareVision: shareVision,
	  LaunchingProductDetails: LaunchingProductDetails
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1498:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _styledComponents = __webpack_require__(1499);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingSection = function (_React$Component) {
	  _inherits(LandingSection, _React$Component);
	
	  function LandingSection() {
	    _classCallCheck(this, LandingSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LandingSection.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        imageURL = _props.imageURL,
	        content = _props.content,
	        alt = _props.alt,
	        iBCalt = _props.iBCalt,
	        iBCLogo = _props.iBCLogo;
	
	    return _react2.default.createElement(
	      _styledComponents.MainContainer,
	      { id: 'team-page-landing-section' },
	      _react2.default.createElement(
	        _ResponsiveContainer2.default,
	        null,
	        _react2.default.createElement(_styledComponents.IBCricketLogo, { src: iBCLogo, alt: iBCalt }),
	        _react2.default.createElement(
	          _styledComponents.MainContentContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.Title,
	            { as: 'h1' },
	            ' ',
	            title,
	            ' '
	          ),
	          _react2.default.createElement(_styledComponents.Image, { src: imageURL, alt: alt }),
	          _react2.default.createElement(
	            _styledComponents.Content,
	            null,
	            ' ',
	            content,
	            ' '
	          )
	        )
	      )
	    );
	  };
	
	  return LandingSection;
	}(_react2.default.Component);
	
	LandingSection.defaultProps = {
	  title: 'iB Cricket is a product of ProYuga',
	  imageURL: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/team-proyuga/proyuga-logo.svg',
	  content: 'We develop transformative products in Virtual, Augmented and Mixed Reality',
	  iBCLogo: 'https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/ib-cricket-logo-reg.png',
	  alt: 'proyuga Logo',
	  iBCalt: 'iB Cricket'
	};
	exports.default = LandingSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1499:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Content = exports.Image = exports.Title = exports.MainContentContainer = exports.IBCricketLogo = exports.MainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'enjifl10'
	})('position:relative;min-height:500px;width:100%;background:url(\'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/Team/team-page-desktop-bg.png\'),linear-gradient(to bottom,', _Colors2.default.blackDefault, ',rgba(18,18,18,0.4)),', _Colors2.default.blackDefault, ';background-size:cover;background-position:50% 100%;');
	
	var IBCricketLogo = /*#__PURE__*/exports.IBCricketLogo = (0, _reactEmotion2.default)('img', {
	  target: 'enjifl11'
	})('position:absolute;height:105px;margin-top:100px;margin-left:20px;', _mixins.mobile, '{height:65px;margin-top:72px;margin-left:unset;}', _mixins.tablet, '{height:95px;}');
	
	var MainContentContainer = /*#__PURE__*/exports.MainContentContainer = (0, _reactEmotion2.default)('div', {
	  target: 'enjifl12'
	})('display:flex;flex-direction:column;align-items:center;justify-content:flex-end;height:500px;');
	
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)(_Din.Typo30WhiteThreeDDI, {
	  target: 'enjifl13'
	})('text-align:center;line-height:normal;', _mixins.mobile, '{font-size:22px;}', _mixins.tablet, '{font-size:26px;}margin:0;');
	
	var Image = /*#__PURE__*/exports.Image = (0, _reactEmotion2.default)('img', {
	  target: 'enjifl14'
	})('width:107px;margin-top:30px;margin-bottom:30px;', _mixins.mobile, '{width:85px;}', _mixins.tablet, '{width:85px;}');
	
	var Content = /*#__PURE__*/exports.Content = (0, _reactEmotion2.default)(_Din.Typo30WhiteDI, {
	  target: 'enjifl15'
	})('margin-bottom:55px;max-width:500px;text-align:center;line-height:1.4;letter-spacing:normal;', _mixins.mobile, '{font-size:22px;}', _mixins.tablet, '{font-size:26px;}');

/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _styledComponents = __webpack_require__(1501);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import MediaQuery from 'react-responsive'
	
	var MentorsandStrategicAdvisors = function (_React$Component) {
	  _inherits(MentorsandStrategicAdvisors, _React$Component);
	
	  function MentorsandStrategicAdvisors() {
	    _classCallCheck(this, MentorsandStrategicAdvisors);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MentorsandStrategicAdvisors.prototype.render = function render() {
	    var mentorsGroupAdvisorsTeamData = this.props.mentorsGroupAdvisorsTeamData;
	    var heading = mentorsGroupAdvisorsTeamData.heading,
	        mentorsGroupAdvisorsMembersList = mentorsGroupAdvisorsTeamData.mentorsGroupAdvisorsMembersList;
	
	
	    return React.createElement(
	      _styledComponents.MentorsSectionWrapper,
	      { id: 'proyuga-team-mentors' },
	      React.createElement(
	        _styledComponents.MentorsandStrategicAdvisorsSection,
	        null,
	        React.createElement(
	          _styledComponents.MentorsandStrategicAdvisorsHeading,
	          { as: 'h3' },
	          heading
	        ),
	        React.createElement(
	          _styledComponents.MentorContainer,
	          null,
	          mentorsGroupAdvisorsMembersList.map(function (eachMentor) {
	            return React.createElement(
	              _styledComponents.MentorsDetailsContainer,
	              null,
	              React.createElement(_styledComponents.MentorImage, {
	                dataSrc: eachMentor.profilePic,
	                alt: eachMentor.name,
	                className: 'lazyload'
	              }),
	              React.createElement(
	                _styledComponents.MentorName,
	                { as: 'article' },
	                eachMentor.name
	              ),
	              React.createElement(
	                _styledComponents.MentorDesignation,
	                { as: 'article' },
	                eachMentor.designation
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return MentorsandStrategicAdvisors;
	}(React.Component);
	
	exports.default = MentorsandStrategicAdvisors;
	module.exports = exports['default'];

/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MentorContainer = exports.MentorName = exports.MentorImage = exports.MentorsDetailsContainer = exports.MentorDesignation = exports.MentorsandStrategicAdvisorsHeading = exports.MentorsandStrategicAdvisorsSection = exports.MentorsSectionWrapper = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styedComponents = __webpack_require__(450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MentorsSectionWrapper = /*#__PURE__*/exports.MentorsSectionWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'euu0ykn0'
	})('background:', _Colors2.default.white, ';');
	
	var MentorsandStrategicAdvisorsSection = /*#__PURE__*/exports.MentorsandStrategicAdvisorsSection = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'euu0ykn1'
	})('font-size:16px;padding:0px 0px 64px 0px;');
	
	var MentorsandStrategicAdvisorsHeading = /*#__PURE__*/exports.MentorsandStrategicAdvisorsHeading = (0, _reactEmotion2.default)(_styedComponents.SectionHeading, {
	  target: 'euu0ykn2'
	})('margin-bottom:34px;margin-top:0;');
	
	var MentorDesignation = /*#__PURE__*/exports.MentorDesignation = (0, _reactEmotion2.default)(_Din.Typo16GainsBoroDD, {
	  target: 'euu0ykn3'
	})('color:', _Colors2.default.charcoalGreyTwo, ';text-align:center;');
	
	var MentorsDetailsContainer = /*#__PURE__*/exports.MentorsDetailsContainer = (0, _reactEmotion2.default)('div', {
	  target: 'euu0ykn4'
	})('display:flex;flex-direction:column;justify-content:center;align-items:center;margin:auto 28px;@media (min-width:320px) and (max-width:426px){margin:auto;margin-bottom:1.875em;}');
	
	var MentorImage = /*#__PURE__*/exports.MentorImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'euu0ykn5'
	})('width:8.75em;');
	
	var MentorName = /*#__PURE__*/exports.MentorName = (0, _reactEmotion2.default)(_Din.Typo20WhiteFourDD, {
	  target: 'euu0ykn6'
	})('color:', _Colors2.default.charcoalGreyTwo, ';line-height:normal;letter-spacing:normal;text-align:center;margin-top:0.9375em;');
	var MentorContainer = /*#__PURE__*/exports.MentorContainer = (0, _reactEmotion2.default)('div', {
	  target: 'euu0ykn7'
	})('display:flex;flex-direction:row;justify-content:center;align-items:center;@media (min-width:320px) and (max-width:426px){width:100%;margin:unset;flex-direction:column;}@media (min-width:426px) and (max-width:768px){width:100%;margin:unset;justify-content:space-evenly;}@media (min-width:769px) and (max-width:1024px){width:50%;justify-content:space-evenly;margin:auto;}');

/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(449);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamCount = function (_React$Component) {
	  _inherits(TeamCount, _React$Component);
	
	  function TeamCount() {
	    _classCallCheck(this, TeamCount);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TeamCount.prototype.render = function render() {
	    var teamCountContent = this.props.teamCountContent;
	
	    return _react2.default.createElement(
	      _styledComponents.TeamCountSection,
	      null,
	      _react2.default.createElement(
	        _styledComponents.TeamCountDescription,
	        { as: 'p' },
	        teamCountContent
	      )
	    );
	  };
	
	  return TeamCount;
	}(_react2.default.Component);
	
	exports.default = TeamCount;
	module.exports = exports['default'];

/***/ }),

/***/ 1503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styedComponents = __webpack_require__(450);
	
	var _TeamCount = __webpack_require__(1502);
	
	var _TeamCount2 = _interopRequireDefault(_TeamCount);
	
	var _styledComponents = __webpack_require__(449);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductCard = function (_React$PureComponent) {
	  _inherits(ProductCard, _React$PureComponent);
	
	  function ProductCard() {
	    _classCallCheck(this, ProductCard);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  ProductCard.prototype.render = function render() {
	    var coreTeamData = this.props.coreTeamData;
	    var heading = coreTeamData.heading,
	        manyMoreText = coreTeamData.manyMoreText,
	        teamMembersList = coreTeamData.teamMembersList;
	
	
	    return _react2.default.createElement(
	      _styledComponents.TeamProfilesSection,
	      { id: 'proyuga-team-profiles' },
	      _react2.default.createElement(
	        _styledComponents.TeamProfilesContainer,
	        null,
	        _react2.default.createElement(
	          _styedComponents.SectionHeading,
	          { as: 'h3' },
	          heading
	        ),
	        _react2.default.createElement(
	          _styledComponents.TeamProfiles,
	          null,
	          teamMembersList.map(function (eachTeamMember) {
	            return _react2.default.createElement(
	              _styledComponents.TeamProfilesCardContainer,
	              { key: eachTeamMember.name },
	              _react2.default.createElement(_styledComponents.TeamProfilesImage, {
	                dataSrc: eachTeamMember.picUrl,
	                alt: eachTeamMember.name,
	                className: 'lazyload'
	              }),
	              _react2.default.createElement(
	                _styledComponents.TeamProfileContent,
	                null,
	                _react2.default.createElement(
	                  _styledComponents.TeamProfilesName,
	                  { as: 'article' },
	                  eachTeamMember.name
	                ),
	                _react2.default.createElement(
	                  _styledComponents.TeamProfilesDesignation,
	                  { as: 'article' },
	                  eachTeamMember.position
	                ),
	                _react2.default.createElement(
	                  _styledComponents.TeamProfilesUniversity,
	                  { as: 'article' },
	                  eachTeamMember.college
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(_TeamCount2.default, { teamCountContent: manyMoreText })
	    );
	  };
	
	  return ProductCard;
	}(_react2.default.PureComponent);
	
	exports.default = ProductCard;
	module.exports = exports['default'];

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TitleUnderLine = exports.Title = exports.TitleContainer = exports.TeamCountSecondBackground = exports.TeamCountDescription = exports.TeamCountBackground = exports.TeamCountSection = exports.TeamProfiles = exports.TeamProfilesSection = exports.TeamProfilesUniversity = exports.TeamProfilesDesignation = exports.TeamProfilesName = exports.TeamProfilesCardContainer = exports.TeamProfileContent = exports.TeamProfilesImage = exports.TeamHeading = exports.TeamProfilesImageContainer = exports.TeamProfilesContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	var _Nort = __webpack_require__(11);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamProfilesContainer = /*#__PURE__*/exports.TeamProfilesContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'e11tdsoj0'
	})();
	var TeamProfilesImageContainer = /*#__PURE__*/exports.TeamProfilesImageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj1'
	})('color:green;');
	var TeamHeading = /*#__PURE__*/exports.TeamHeading = (0, _reactEmotion2.default)('article', {
	  target: 'e11tdsoj2'
	})('font-family:din-2014;font-size:32px;font-weight:300;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:-0.5px;color:#344564;margin-bottom:60px;text-align:center;');
	var TeamProfilesImage = /*#__PURE__*/exports.TeamProfilesImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e11tdsoj3'
	})('width:7.5em;height:7.5em;object-fit:contain;@media only screen and (min-width:320px) and (max-width:767px){width:70px;height:70px;margin-right:10px;}');
	var TeamProfileContent = /*#__PURE__*/exports.TeamProfileContent = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj4'
	})('@media only screen and (min-width:320px) and (max-width:767px){display:flex;flex-direction:column;align-items:flex-start;}');
	var TeamProfilesCardContainer = /*#__PURE__*/exports.TeamProfilesCardContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj5'
	})('display:flex;flex-direction:column;width:14em;align-items:center;justify-content:flex-start;margin-bottom:3.375em;@media only screen and (min-width:320px) and (max-width:767px){flex-direction:row;width:85%;}');
	var TeamProfilesName = /*#__PURE__*/exports.TeamProfilesName = (0, _reactEmotion2.default)(_Din.Typo16WhiteFourDD, {
	  target: 'e11tdsoj6'
	})('color:', _Colors2.default.charcoalGreyTwo, ';letter-spacing:normal;text-align:center;margin-top:9px;@media only screen and (min-width:320px) and (max-width:767px){font-size:14px;margin-top:0px;}');
	var TeamProfilesDesignation = /*#__PURE__*/exports.TeamProfilesDesignation = (0, _reactEmotion2.default)(_Din.Typo14PinkishGreyDR, {
	  target: 'e11tdsoj7'
	})('color:', _Colors2.default.charcoalGreyTwo, ';letter-spacing:normal;text-align:center;@media (min-width:320px) and (max-width:425px){text-align:left;}');
	var TeamProfilesUniversity = /*#__PURE__*/exports.TeamProfilesUniversity = (0, _reactEmotion2.default)(_Din.Typo12PinkishGreyDR, {
	  target: 'e11tdsoj8'
	})('color:', _Colors2.default.charcoalGreyTwo, ';text-align:center;margin-top:0.125em;');
	var TeamProfilesSection = /*#__PURE__*/exports.TeamProfilesSection = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj9'
	})('font-size:16px;padding-top:60px;padding-bottom:60px;background:', _Colors2.default.white, ';@media (min-width:320px) and (max-width:767px){font-size:14px;padding-top:5em;}');
	var TeamProfiles = /*#__PURE__*/exports.TeamProfiles = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj10'
	})('display:flex;justify-content:center;flex-wrap:wrap;');
	var TeamCountSection = /*#__PURE__*/exports.TeamCountSection = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj11'
	})('display:flex;flex-direction:row;justify-content:center;align-items:center;width:93.5%;margin-left:auto;margin-right:auto;@media (min-width:320px) and (max-width:435px){flex-direction:column;}');
	var TeamCountBackground = /*#__PURE__*/exports.TeamCountBackground = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj12'
	})('width:7.5em;height:7.5em;border-radius:68.1px;background-color:#0b569a;');
	var TeamCountDescription = /*#__PURE__*/exports.TeamCountDescription = (0, _reactEmotion2.default)(_Din.Typo25WhiteDD, {
	  target: 'e11tdsoj13'
	})('color:', _Colors2.default.darkGreyBlue, ';font-weight:normal;margin:0px;', _mixins.mobile, '{text-align:center;}');
	
	var TeamCountSecondBackground = /*#__PURE__*/exports.TeamCountSecondBackground = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj14'
	})('width:7.5em;height:7.5em;border-radius:68.1px;background-color:#0b569a;margin-left:7.5em;@media (min-width:320px) and (max-width:435px){margin-left:0;margin-top:2.5em;}');
	
	var TitleContainer = /*#__PURE__*/exports.TitleContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj15'
	})('width:100%;display:flex;flex-direction:column;align-items:center;margin-bottom:50px;margin-top:60px;');
	var Title = /*#__PURE__*/exports.Title = (0, _reactEmotion2.default)(_Nort.Typo30DarkGreyBlueTwoNBI, {
	  target: 'e11tdsoj16'
	})('text-align:center;line-height:normal;', _mixins.mobile, '{font-size:24px;}margin:0;');
	var TitleUnderLine = /*#__PURE__*/exports.TitleUnderLine = (0, _reactEmotion2.default)('div', {
	  target: 'e11tdsoj17'
	})('width:100px;height:2px;background-color:', _Colors2.default.ceruleanBlue, ';margin:auto;margin-top:10px;');

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SectionHeading = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionHeading = /*#__PURE__*/exports.SectionHeading = (0, _reactEmotion2.default)(_Din.Typo26PumpkinOrangeDBI, {
	  target: 'exjppku0'
	})('color:', _Colors2.default.twilightBlue, ';text-align:center;margin-bottom:34px;', _mixins.mobile, '{font-size:24px;}', _mixins.tabletSpecialUseCase, '{font-size:28px;}margin-top:0;');

/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.teamGraphql = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(20);
	
	var _TeamProfiles = __webpack_require__(1503);
	
	var _TeamProfiles2 = _interopRequireDefault(_TeamProfiles);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _MentorsandStrategicAdvisors = __webpack_require__(1500);
	
	var _MentorsandStrategicAdvisors2 = _interopRequireDefault(_MentorsandStrategicAdvisors);
	
	var _LandingSection = __webpack_require__(1498);
	
	var _LandingSection2 = _interopRequireDefault(_LandingSection);
	
	var _ApplicationSection = __webpack_require__(1491);
	
	var _ApplicationSection2 = _interopRequireDefault(_ApplicationSection);
	
	var _FollowUsSection = __webpack_require__(1495);
	
	var _FollowUsSection2 = _interopRequireDefault(_FollowUsSection);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	var _styledComponents = __webpack_require__(449);
	
	var _AdvisoryCouncilSection = __webpack_require__(1487);
	
	var _AdvisoryCouncilSection2 = _interopRequireDefault(_AdvisoryCouncilSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Team = function (_React$Component) {
	  _inherits(Team, _React$Component);
	
	  function Team() {
	    _classCallCheck(this, Team);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Team.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        headerPropsData = _props.headerPropsData,
	        footerProps = _props.footerProps,
	        isBookNowSlotOpened = _props.isBookNowSlotOpened,
	        bookNowModalData = _props.bookNowModalData;
	
	
	    if (data) {
	      var teamPageData = data.teamPageData;
	      var _teamPageData$edges$ = teamPageData.edges[0].node.frontmatter,
	          title = _teamPageData$edges$.title,
	          seoData = _teamPageData$edges$.seoData,
	          gamingAdvisoryCouncilData = _teamPageData$edges$.gamingAdvisoryCouncilData,
	          coreTeamData = _teamPageData$edges$.coreTeamData,
	          mentorsGroupAdvisorsTeamData = _teamPageData$edges$.mentorsGroupAdvisorsTeamData,
	          developmentServicesData = _teamPageData$edges$.developmentServicesData,
	          trainingsData = _teamPageData$edges$.trainingsData,
	          applicationSectionData = _teamPageData$edges$.applicationSectionData;
	
	
	      return React.createElement(
	        'div',
	        null,
	        React.createElement(
	          _reactHelmet2.default,
	          null,
	          React.createElement(
	            'title',
	            null,
	            seoData.title
	          ),
	          React.createElement('meta', { name: 'description', content: seoData.metaDescription }),
	          React.createElement('meta', { property: 'og:title', content: seoData.ogTitle }),
	          React.createElement('meta', { property: 'og:url', content: seoData.ogWebsiteUrl }),
	          React.createElement('meta', { property: 'og:description', content: seoData.ogDescription }),
	          React.createElement('meta', { property: 'og:type', content: 'website' }),
	          React.createElement('meta', { property: 'og:site_name', content: 'ib.cricket' }),
	          React.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	          React.createElement('meta', { property: 'twitter:title', content: seoData.twitterTitle }),
	          React.createElement('meta', { name: 'twitter:url', content: 'https://ib.cricket/our-team/' }),
	          React.createElement('meta', { name: 'twitter:site', content: '@playiBCricket' }),
	          React.createElement('meta', {
	            property: 'twitter:description',
	            content: seoData.twitterdescription
	          })
	        ),
	        React.createElement(_Header2.default, {
	          isBookNowSlotOpened: isBookNowSlotOpened,
	          bookNowModalData: bookNowModalData,
	          headerPropsData: headerPropsData
	        }),
	        React.createElement(_LandingSection2.default, null),
	        React.createElement(
	          _styledComponents.TitleContainer,
	          null,
	          React.createElement(
	            _styledComponents.Title,
	            { as: 'h2' },
	            title
	          ),
	          React.createElement(_styledComponents.TitleUnderLine, null)
	        ),
	        React.createElement(_AdvisoryCouncilSection2.default, {
	          gamingAdvisoryCouncilData: gamingAdvisoryCouncilData
	        }),
	        React.createElement(_TeamProfiles2.default, { coreTeamData: coreTeamData }),
	        React.createElement(_MentorsandStrategicAdvisors2.default, {
	          mentorsGroupAdvisorsTeamData: mentorsGroupAdvisorsTeamData
	        }),
	        React.createElement(_ApplicationSection2.default, { applicationSectionData: applicationSectionData }),
	        React.createElement(_FollowUsSection2.default, {
	          stakeholdersList: developmentServicesData.servicesList,
	          stakeholdersData: developmentServicesData
	        }),
	        React.createElement(_FollowUsSection2.default, {
	          stakeholdersData: trainingsData,
	          stakeholdersList: trainingsData.trainingsList,
	          invertTheme: true
	        }),
	        React.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	      );
	    }
	    return null;
	  };
	
	  return Team;
	}(React.Component);
	
	exports.default = Team;
	
	// eslint-disable-next-line
	
	var teamGraphql = exports.teamGraphql = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-our-team-index-js-88d54a986a29c2b0ec35.js